import React from "react"
import { OldButton, OldIconButton } from "@kit/design/old-button"

export const ImageActions = ({
  imageEditorButtonVisible,
  showDokaModal,
  openFileGallery,
  removeImage,
  source
}) => {
  const labelText = source => {
    if (!source) {
      return "Choose an image"
    } else {
      return "Replace"
    }
  }

  return (
    <div className="flex items-start w-full">
      {imageEditorButtonVisible && (
        <OldButton
          icon="edit"
          onClick={showDokaModal}
          className="h-10 mr-1 flex-auto"
          size="sm"
          is="secondary"
        >
          Edit
        </OldButton>
      )}
      <OldButton
        icon="cloud-upload"
        onClick={openFileGallery}
        className="h-10 mr-1 flex-auto"
        size="sm"
        is="secondary"
      >
        {labelText(source)}
      </OldButton>
      {source && (
        <OldIconButton
          onClick={removeImage}
          icon="delete"
          is="secondary"
          label="Remove image"
          className="h-10"
        />
      )}
    </div>
  )
}
